// extracted by mini-css-extract-plugin
export default {"root":"_3EVqL","status":"_1B24N","offer":"_1pd8P","text":"_129xg"};